// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ffa3b5d0","830":"d819eb73"}[chunkId] + ".chunk.js";
};